module.exports = require('./colorbrewer.js');



//////////////////
// WEBPACK FOOTER
// ./~/colorbrewer/index.js
// module id = 994
// module chunks = 6